import { useMemo } from "react";

import { useAppSelector } from "../../../app/store";

import { AutoSelectVerticalNav } from "../../../components/ui/navigation/AutoSelectVerticalNav";
import { TabItem } from "../../../components/ui/navigation/VerticalNavPanel";

import { selectFraudElementsForParty } from "../logic/fraudElementsSlice";
import { FRAUD_ELEMENT_CATEGORIES_LABELS } from "../../../api/fraudElements";

interface FraudElementsSidebarProps {
  partyId: string;
  selectedFraudElementId?: string;
  onFraudElementChange?: (fraudElementId: string) => void;
}

export default function FraudElementsSidebar({
  partyId,
  selectedFraudElementId,
  onFraudElementChange,
}: FraudElementsSidebarProps) {
  const fraudElements = useAppSelector((state) =>
    selectFraudElementsForParty(state, partyId),
  );

  const items = useMemo<TabItem[]>(
    () =>
      fraudElements.map((fraudElement) => ({
        id: fraudElement.fraud_element_id,
        header: FRAUD_ELEMENT_CATEGORIES_LABELS[fraudElement.fraud_element_category],
      })),
    [fraudElements],
  );

  return (
    <AutoSelectVerticalNav
      title="Fraud Elements"
      items={items}
      selectedId={selectedFraudElementId}
      onSelectionChange={onFraudElementChange}
      showTitleOnHover={true}
      className="w-[264px] p-2 border-none shadow-none"
      headerClassName="border-none px-2 py-0 h-8 !mb-0 flex items-center justify-between leading-none"
      titleClassName="text-sm font-medium text-[#737373] leading-none"
      listContainerClassName="!pb-0"
      rowClassName="py-2 px-2 rounded-[8px] flex items-center justify-between"
      rowHeaderClassName="!leading-4"
    />
  );
}